import { HTTP_CLIENT } from '../../axios-wrapper'

const state = {
  id: '',
  name: '',
  firstname: '',
  avatar: '',
  showEditUser: false,
  showAddUser: false,
  updateProfil: false
}

const getters = {
  getUserId: state => state.id,
  getUserName: state => state.name,
  getUserFirstname: state => state.firstname,
  getAvatar: state => state.avatar,
  getShowEditUser: state => state.showEditUser,
  getShowAddUser: state => state.showAddUser,
  getUpdateProfil: state => state.updateProfil
}

const actions = {
  'GET_USER_INFOS': ({ commit }, userInfos) => {
    commit('SET_USER_INFOS', userInfos)
  },
  'GET_AVATAR': ({ commit }, userId) => {
    return new Promise((resolve, reject) => {
      HTTP_CLIENT
        .get(`user/avatar/${userId}`)
        .then(response => {
          commit('SET_AVATAR', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

const mutations = {
  'SET_USER_INFOS': (state, userInfos) => {
    state.id = userInfos.id
    state.name = userInfos.name
    state.firstname = userInfos.firstname
  },
  'SET_AVATAR': (state, avatar) => {
    state.avatar = avatar
  },
  'SET_USER_NAME': (state, name) => {
    state.name = name
  },
  'SET_USER_FIRSTNAME': (state, firstname) => {
    state.firstname = firstname
  },
  'SHOW_EDIT_USER_POPUP': (state, showEditUser) => { state.showEditUser = showEditUser },
  'SHOW_ADD_USER_POPUP': (state, showAddUser) => { state.showAddUser = showAddUser }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
